import type {StatusBadgeProps} from 'shells/status-badge/status-badge';

import type {
    GetManagedMeetingsTemplates_managedMeetings as ManagedMeeting,
    MeetingFragment,
} from 'nutshell-graphql-types';

export function getStatusBadge(meeting: ManagedMeeting | MeetingFragment): StatusBadgeProps {
    if (meeting.deletedTime) {
        return {level: 'hidden', text: 'Archived'};
    }

    if (meeting.assignments && meeting.assignments.totalCount > 0) {
        return {level: 'success', text: 'Assigned'};
    } else {
        return {level: 'info--grey', text: 'Unassigned'};
    }
}

export function getStatusBarPrimaryText(userCount: number, teamCount: number): string {
    if (userCount > 0 && teamCount > 0) {
        return `Assigned to ${teamCount} ${teamCount === 1 ? 'team' : 'teams'} and ${userCount} ${
            userCount === 1 ? 'user' : 'users'
        }`;
    } else if (userCount > 0) {
        return `Assigned to ${userCount} ${userCount === 1 ? 'user' : 'users'}`;
    } else if (teamCount > 0) {
        return `Assigned to ${teamCount} ${teamCount === 1 ? 'team' : 'teams'}`;
    }

    return 'Assign this meeting to users to get started';
}
